import React from "react";
import { Button, Container } from "react-bootstrap";
import Header from "../Header";
import Footer from "../Footer";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { blobURL } from "common/StringUtils";
import { useEffect } from "react";
import LinkPhoneNumber from "../../LinkPhoneNumber";
import { LOCALES } from "common/constants";
import { getSchemaMarkup } from "common/FunctionUtils";

const Negotiation = ({ dashboardFooter }) => {
  const schemaMarkup = getSchemaMarkup("fran-faktura-till-forhandling");
  const { t } = useTranslation();
  const navigate = useNavigate();

  const user = useSelector((state) => state.auth.user);
  const invoiceNegotation = `${blobURL}/negotation.png`;
  let language = localStorage.getItem("i18nextLng");

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <Helmet>
        {schemaMarkup && (
          <script type="application/ld+json">
            {JSON.stringify(schemaMarkup)}
          </script>
        )}
        <title>{t("Assignment negotiation Help - Contact Invozio")}</title>
        <meta
          name="description"
          content={t(
            "Not sure about compensation and conditions for your assignment? Invozio helps you negotiate with your client. Contact us for more information."
          )}
        />
        {language === LOCALES.EN_US ? (
          <link
            rel="canonical"
            href="https://invozio.com/from-invoice-to-negotiation"
          />
        ) : (
          <link
            rel="canonical"
            href="https://invozio.com/fran-faktura-till-forhandling"
          />
        )}
      </Helmet>

      <Header />
      <Container className="p-0 self_new negotiate neg_rspn">
        <div className="negotiation_wrap new_desgn_insurance new_margin_header px-0 p-0">
          <section className="insurns_wrap negotiation neg2 ">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6 col-md-6">
                  <div className="security_fntw">
                    <h1 className="security_about text-uppercase mb-0">
                      {t("The negotiation call")}
                    </h1>
                    <h3 className="fnt_family">
                      {t("From invoice to negotiation")}
                    </h3>
                    <div className="new_text_cntr">
                      {!user && (
                        <Button
                          variant=""
                          className="mt-3 new_theme_btn "
                          onClick={() =>
                            navigate(
                              language === LOCALES.EN_US
                                ? `/emailregister?lang=${LOCALES.EN_US}`
                                : `/e-postregister?lang=${LOCALES.SV_SE}`
                            )
                          }
                        >
                          {t("Create Free Account")}
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="text-right">
                    <div className="image_wrap">
                      <img
                        src={invoiceNegotation}
                        alt="negotiation"
                        className="image-fluid"
                        loading="lazy"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="newdesign pb-0">
            <div className="container p-0">
              <div className="without_background">
                <h5>{t("From invoice to negotiation")}</h5>
                <p>
                  {t(
                    "Being a freelancer means freedom and flexibility, but it also brings some challenges. One of these challenges is deciding what compensation and terms you should request for your assignment. It can be a complicated process, especially if you are new to the freelancing world. But don't worry, we at Invozio are here to help you. We have specialized in assisting freelancers in everything from invoicing to negotiation. Our expert team is equipped with the right skills and experience to negotiate for you and ensure you are paid fairly for your work"
                  )}
                </p>
                <p className="insurance_para mb-2">
                  {t(
                    "New solutions are needed in today's labor market where a permanent form of employment is no longer an obvious choice if you want to be able to influence your work situation but still feel secure. Self-employment can be both a way into the labor market as you can get paid for temporary assignments, or a first step when you want to test your business idea when you are considering starting your own company."
                  )}
                </p>
                <div className="new_text mt-2">
                  <h6 className="mb-2 accident_ins">
                    {t(
                      "Invozio takes care of the entire process from negotiation to invoicing"
                    )}
                  </h6>
                  <p>
                    {t(
                      "Invozio takes care of the entire process, allowing you to focus on your work and what you love. We take care of all the administrative stuff, such as drawing up and sending invoices and negotiating with your clients. Our service is designed to make it easier for freelancers to invoice without a company. We handle invoices for thousands of freelancers every day, so you can be sure that your assignment and your money are in safe hands."
                    )}
                  </p>
                </div>
              </div>
              <div className="with_background neg">
                <h5>{t("What you get as a freelancer")}</h5>
                <p className="insurance_para mb-2">
                  {t(
                    "As a freelancer with Invozio, you get more than just invoicing services. We become your partner and advisor, always ready to support and guide you through your freelance journey. We can also help negotiate prices and terms for your assignments, which can give you an advantage and ensure you get the compensation you deserve. We believe in the power of collaboration and are happy to share our expertise to help you grow and develop as a freelancer."
                  )}
                </p>
                <p className="mt-2">
                  {t(
                    "Please contact us for more information. You can reach us by phone at"
                  )}{" "}
                  <span className="accident_ins">
                    <LinkPhoneNumber />
                  </span>{" "}
                  {t("or email at")}{" "}
                  <span className="accident_ins">
                    <a href="mailto:support@invozio.com">
                      {" "}
                      support@invozio.com{" "}
                    </a>{" "}
                  </span>
                  {t(
                    "We look forward to hearing from you and helping you on your freelance journey!"
                  )}{" "}
                </p>
              </div>
            </div>
          </section>
        </div>
      </Container>
      <Footer dashboardFooter={dashboardFooter} />
    </>
  );
};

export default Negotiation;
